var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('p',[_vm._v("Permissions management will be implemented here.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }